var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import orderBy from 'lodash/orderBy';
import CompanyStore from 'stores/CompanyStore/store';
import GamesStore from 'stores/GamesStore/store';
import { isAllowedHelper } from 'utils/Permissions';
import { Permissions } from 'constants/Permissions';
import { setUserPushToken, addUserToKnock } from 'actions/ServerActionCreators';
import isPushTokenRegistrationMessage from 'utils/PushTokenUtils';
import GameCard from '../player/GameCard';
function getStateFromStores() {
    var data = CompanyStore.getCompanyInfo();
    return __assign(__assign({}, data), { games: GamesStore.getAllGames() });
}
var Games = /** @class */ (function (_super) {
    __extends(Games, _super);
    function Games(props) {
        var _this = _super.call(this, props) || this;
        // This launches on the Games screen because it is the defacto home page
        // if the home location changes the message handler will need to move with it
        // Todo: clean up switch statement, we don't need a switch there will only be one message
        _this.handleWebViewMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var message, data, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        message = JSON.parse(event.data);
                        console.log('Message from WebView:', message);
                        data = [];
                        data.push({
                            userId: ((_a = this.state.current_user) === null || _a === void 0 ? void 0 : _a.id) || 0,
                            pushToken: message.token
                        });
                        if (!isPushTokenRegistrationMessage(message.type)) return [3 /*break*/, 3];
                        console.log("Registering push token (".concat(message.type, ")"));
                        return [4 /*yield*/, addUserToKnock(data)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, setUserPushToken(data)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        console.warn('Unknown message type:', message.type);
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        console.log(error_1);
                        console.error('Invalid message:', event.data);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.state = getStateFromStores();
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.handleWebViewMessage = _this.handleWebViewMessage.bind(_this);
        return _this;
    }
    Games.prototype.componentDidMount = function () {
        CompanyStore.addChangeListener(this.onChangeHandler);
        GamesStore.addChangeListener(this.onChangeHandler);
        window.addEventListener('message', this.handleWebViewMessage);
        var windowWithListener = window;
        windowWithListener.messageListener = this.handleWebViewMessage;
    };
    Games.prototype.componentWillUnmount = function () {
        CompanyStore.removeChangeListener(this.onChangeHandler);
        GamesStore.removeChangeListener(this.onChangeHandler);
        window.removeEventListener('message', this.handleWebViewMessage);
    };
    Games.prototype.onChangeHandler = function () {
        this.setState(getStateFromStores());
    };
    Games.prototype.render = function () {
        var _this = this;
        var games;
        if (isAllowedHelper(CompanyStore, Permissions.VIEW_CUSTOM_GAMES)) {
            games = this.state.games;
        }
        else {
            games = this.state.games.filter(function (game) { return game.settings.is_managed_game; });
        }
        var accountId = this.state &&
            this.state.current_user &&
            parseInt(String(this.state.current_user.account_id), 10);
        var gameDataMapper = function (game) {
            var gameAccountId = game && game.settings && parseInt(String(game.settings.account_id), 10);
            return __assign(__assign({}, game), { id: parseInt(String(game.settings.id), 10), isCrossAccount: accountId !== gameAccountId, isManagedGame: game.settings.is_managed_game ? 1 : 0 });
        };
        games = games.map(gameDataMapper);
        games = orderBy(games, ['isCrossAccount', 'isManagedGame', 'id'], ['asc', 'asc', 'desc']);
        var gameCards = games.filter(Boolean).map(function (game) {
            var gameId = game && game.settings && game.settings.id;
            return (_jsx(GameCard, { game: game, timezone: _this.state.account.timezone, mobileApp: true }, gameId));
        });
        return (_jsxs("div", { className: "sb-app-main", children: [_jsx("h1", { className: "activity-heading", children: "Active games" }), _jsx("div", { className: "active-games-list", children: gameCards })] }));
    };
    return Games;
}(React.Component));
export default Games;
